import React from 'react'
import Icon from './Icon'

const Copy = props => (
  <Icon {...props}>
    <svg width='18px' height='18px' viewBox='0 0 64 64'>
      <path
        data-name='layer2'
        fill='none'
        stroke='#858485'
        strokeMiterlimit='10'
        strokeWidth='5'
        d='M16 16h46v46H16z'
        strokeLinejoin='round'
        strokeLinecap='round'
      />
      <path
        data-name='layer2'
        fill='none'
        stroke='#858485'
        strokeMiterlimit='10'
        strokeWidth='5'
        d='M16 48H2V2h46v14'
        strokeLinejoin='round'
        strokeLinecap='round'
      />
      <path
        data-name='layer1'
        fill='none'
        stroke='#858485'
        strokeMiterlimit='10'
        strokeWidth='5'
        d='M39 26v26m13-13H26'
        strokeLinejoin='round'
        strokeLinecap='round'
      />
    </svg>
  </Icon>
)

export default Copy
